import {css, html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../../WebComponent.js'
import '../../../components/Verbrauch/GasConsumptionPlot.js'
import '@isceco/widget-library2/basic-elements/Filter/DateFilter.js'
import ChartService from "./ChartService";
import DateFilterItem from '@isceco/widget-library2/basic-elements/Filter/DateFilterItem.js'
import {List} from '@isceco/widget-library2/basic-elements/List/List.js'
import I18n from "../../../i18n"
import AuthorizationFilter from '../../Authorization/AuthorizationFilter.js'
import AdminService from '../../../services/AdminService.js'

export default class VerbrauchRegion extends WebComponent {

  get css() {
    return css`
      isceco-title:first-of-type {
        display: block;
        margin-top: -20px;
      }

      .title-content {
        display: flex;
        gap: 1em;
        margin-bottom: 0.5em;
        align-items: center;
      }

      .flexRowView {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
      }

      .container {
        display: flex;
        gap: 1em;
      }

      .diagram {
        flex: 1;
      }

      .filter {
        flex: 0;
        margin-bottom: 15px;
      }

      isceco-date-filter {
        margin: 0;
        display: block;
      }

      .js-plotly-plot {
        background-color: var(--isceco-color-white-500);
        box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 4px 0px;
        border-radius: 4px !important;
      }
    `
  }

  get translationFile() {
    return './views/Verbrauch/Region/i18n.json'
  }

  constructor() {
    super()
    this.adminService = new AdminService()
    this.chartService = new ChartService()
    this.defaultStartDate = this.addDays(new Date(), -14);
    this.startDate = this.addDays(new Date(), -14);
    this.defaultEndDate = this.addDays(new Date(), +13);
    this.endDate = this.addDays(new Date(), +13);
    this.minDate = new Date("2024-12-01");
    this.maxDate = this.addDays(new Date(), +13);
    this.dates = []
    this.gasConsumption = []
    this.temperature = []
    this.gasConsumptionPrognose = []
    this.gasConsumptionMlPrognose = []
    this.gebKapazitaet = []
    this.nomKapazitaet = []
    this.dateFilters = []
    this.region = this.getAttribute('region');
    this.mlParameter = {
      activated: false
    }
  }

  connectedCallback() {
    super.connectedCallback()

    this._refresh = () => {
      document.getElementById('plotverbrauch'+this.region).requestUpdate()
    }
    document.addEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)
    document.addEventListener(List.EVENT_KEYS.RELOAD_TRIGGERED, this.updateFilter)

    this.dateFilters = [
      new DateFilterItem({
        start: offsetDate({m: -3}),
        end: this.getDateString(this.defaultEndDate)
      }, 'gas.verbrauch.date.filter.last.months', {months: 3}),
      new DateFilterItem({
        start: offsetDate({m: -6}),
        end: this.getDateString(this.defaultEndDate)
      }, 'gas.verbrauch.date.filter.last.months', {months: 6}),
      new DateFilterItem({
        start: offsetDate({y: -1}),
        end: this.getDateString(this.defaultEndDate),
      }, 'gas.verbrauch.date.filter.lastYear')
    ]

    this.getData();
  }

  disconnectedCallback() {
    document.removeEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)
    document.removeEventListener(List.EVENT_KEYS.RELOAD_TRIGGERED, this.updateFilter)
  }

  getData() {
    const startDateString = this.startDate.toISOString().split('T')[0];
    const endDateString = this.endDate.toISOString().split('T')[0];

    Promise.all([
      this.adminService.list('ml-parameter'),
      this.chartService.getTemperatur(this.region, startDateString, endDateString),
      this.chartService.getVerbrauch(this.region, startDateString, endDateString),
      this.chartService.getVerbrauchPrognose(this.region, startDateString, endDateString),
      this.chartService.getVerbrauchMlPrognose(this.region, startDateString, endDateString),
      this.chartService.getGebuchteKapazitaet(this.region, startDateString, endDateString),
      this.chartService.getNominierteKapazitaet(this.region, startDateString, endDateString)])
      .then(([mlParameter, temperature, gasConsumption,
               gasConsumptionPrognose, gasConsumptionMlPrognose, gebKapazitaet,
               nomKapazitaet]) => {
        if (mlParameter.length > 0) {
          this.mlParameter.activated = mlParameter[0].activated
        }
        this.dates = temperature.map(a => a.date)
        this.temperature = temperature.map(a => a.value)
        this.gasConsumption = gasConsumption.map(a => a.value / 1000)
        this.gasConsumptionPrognose = gasConsumptionPrognose.map(a => a.value / 1000)
        this.gasConsumptionMlPrognose = gasConsumptionMlPrognose.map(a => a.value / 1000)
        this.gebKapazitaet = gebKapazitaet.map(a => a.value / 1000)
        this.nomKapazitaet = nomKapazitaet.map(a => a.value / 1000000)
        this.render()
      }).catch(_ => this.reload())
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate(`gas.verbrauch.${this.region}.title`)}"
      ></isceco-title>
      <div class="filter">
        <isceco-date-filter
          .i18n="${this.i18n}"
          label="${this.i18n.translate('gas.verbrauch.date.filter.label')}"
          .items="${this.dateFilters}"
          key="date">
        </isceco-date-filter>
      </div>
     <gas-verbrauch-plot
          id="plotverbrauch${this.region}"
          .i18n="${this.i18n}"
          source="verbrauch"
          region="${this.region}"
          .dates="${this.dates}"
          .temperature="${this.temperature}"
          .gasConsumption="${this.gasConsumption}"
          .gasConsumptionPrognose="${this.gasConsumptionPrognose}"
          .gasConsumptionMlPrognose="${this.gasConsumptionMlPrognose}"
          .gasConsumptionMlPrognoseVisible="${this.mlParameter.activated}"
          .gebKapazitaet="${this.gebKapazitaet}"
          .nomKapazitaet="${this.nomKapazitaet}"
        ></gas-verbrauch-plot>
      <div class="container">
        <div class="diagram">
          <div class="flexRowView">
            <p>${this.i18n.translate('gas.verbrauch.daterange.backward.button')}</p>
            <isceco-button
              id="kapazitaet-zeitraum-zurueck"
              variant="primary"
              size="small"
              icon="step backward"
              title="${this.i18n.translate('gas.verbrauch.daterange.backward.button')}"
              ?disabled="${this.isBackwardButtonDisabled()}"
              @click="${_ => {
                this.changePeriod('previous')
              }}"
            ></isceco-button>
            <isceco-button
              id="kapazitaet-zeitraum-vorwaerts"
              variant="primary"
              size="small"
              icon="step forward"
              title="${this.i18n.translate('gas.verbrauch.daterange.forward.button')}"
              ?disabled="${this.isForwardButtonDisabled()}"
              @click="${_ => {
                this.changePeriod('next')
              }}"
            ></isceco-button>
            <p>${this.i18n.translate('gas.verbrauch.daterange.forward.button')}</p>
            ${
               AuthorizationFilter._hasRoleAdmin() ? html`
                 <isceco-button id="export" variant="secondary" size="small" icon="download" style="margin-left: auto;"
                                .hidden="${AuthorizationFilter._hasRoleAdmin()}"
                                @click="${_ => {
                                  // Merging arrays into a single array of objects
                                  const mergedData = this.dates.map((date, index) => ({
                                    date,
                                    temperature: this.temperature[index],
                                    gasConsumption: this.gasConsumption[index],
                                    gasConsumptionPrognose: this.gasConsumptionPrognose[index],
                                    gebKapazitaet: this.gebKapazitaet[index],
                                    nomKapazitaet: this.nomKapazitaet[index]
                                  }));
                                  this.exportToCSV(mergedData, 'export_region_'+this.region)
                                }}"
                 ></isceco-button>
               ` : html``
            }
          </div>
        </div>
      </div>
    `
  }

  addDays(date, days) {
    date.setDate(date.getDate() + days);
    return date;
  }

  changePeriod(direction) {
    const diffTime = Math.abs(this.endDate - this.startDate);
    let diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (direction === 'previous') {
      diffDays = -diffDays
    }

    this.startDate = this.addDays(this.startDate, diffDays)
    this.endDate = this.addDays(this.endDate, diffDays)

    this.getData();
  }

  updateFilter = event => {
    if (event.detail.value.from === null || event.detail.value.to === null) {
      this.startDate = this.defaultStartDate;
      this.endDate = this.defaultEndDate;
    } else {
      this.startDate = new Date(event.detail.value.from);
      this.endDate = new Date(event.detail.value.to);
    }
    this.getData();
  }

  isBackwardButtonDisabled() {
    return this.startDate <= this.minDate.getTime();
  }

  isForwardButtonDisabled() {
    return this.endDate.getTime() >= this.maxDate.getTime();
  }

  getDateString(date) {
    return new Date(date).toISOString().split('T')[0];
  }

  exportToCSV(data, filename = 'VerbrauchRegion.csv') {
    // Define the title and column names
    const title = this.i18n.translate(`gas.verbrauch.${this.region}.title`).replaceAll(', ','/')
    const columnNames = [
      this.i18n.translate(`gas.verbrauch.datum`),
      this.i18n.translate(`gas.verbrauch.temperatur`),
      this.i18n.translate(`gas.verbrauch.verbrauch`),
      this.i18n.translate(`gas.verbrauch.prog.verbrauch`),
      this.i18n.translate(`gas.verbrauch.geb.kapa`),
      this.i18n.translate(`gas.verbrauch.nom.kapa`)
    ]
    // Create the CSV content
    const csvContent = [
      title,
      columnNames.join(','),
      ...data.map(row => Object.values(row).join(','))
    ].join('\n')
    // Create a Blob from the CSV content
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    // Create a link element
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    // Set the link's attributes
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    // Append the link to the document
    document.body.appendChild(link);
    // Programmatically click the link to trigger the download
    link.click()
    // Clean up
    document.body.removeChild(link)
  }

}
customElements.define('gasmonitoring-frontend-verbrauch-region', VerbrauchRegion)
